var rUpper = /([A-Z])/g;
export default function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/hyphenate.js
// module id = 2593
// module chunks = 121